import Text from '../../generic/Text';
import { AuthContextState } from '../context/AuthContext';

type FormHeadingProps = Partial<Pick<AuthContextState, 'orgTitle'>> & {
  heading: string;
};

/**
 * Heading component for the AuthForm.
 */
const AuthFormHeading = ({ heading, orgTitle }: FormHeadingProps) => {
  //  For the registration page, we may show the orgTitle if the user lands
  //  on this page with an invite token in the query params.
  return (
    <>
      <Text.H1>
        {heading}
      </Text.H1>
      {orgTitle ? (
        <span className="fossa-auth__form__heading__org-title">
          {orgTitle}
        </span>
      ) : null}
    </>
  );
};

export default AuthFormHeading;
